"use client";

import React from "react";
import { InView } from "react-intersection-observer";
import cn from "classnames";

import styles from "./AscAnimationOnScroll.module.scss";

export type AscAnimationOnScrollProps = {
  children: React.ReactNode;
  as?: "div" | "span" | "aside" | "section" | "main";
  className?: string;
};

export default function AscAnimationOnScroll({
  children,
  as: Tag = "div",
  className,
}: AscAnimationOnScrollProps) {
  return (
    <Tag className={className}>
      {React.Children.map(children, (child) => (
        <InView triggerOnce threshold={0.24}>
          {({ inView, ref, entry }) => (
            <div
              ref={ref}
              className={cn(
                styles.animation,
                entry?.isIntersecting && styles.visible
              )}
            >
              {child}
            </div>
          )}
        </InView>
      ))}
    </Tag>
  );
}
